export default __webpack_public_path__ + "static/m-fullapp-c22a84f01bb09652ecffa3e6b467a852.jpg";